import { useEffect, useRef, useState } from "react";
import { Appearance, ColorSchemeName } from "react-native";

export const useTheme = () => {
  const [theme, setTheme] = useState<ColorSchemeName>(
    Appearance.getColorScheme()
  );

  useEffect(() => {
    const apperanceChangeListener = Appearance.addChangeListener(
      ({ colorScheme }) => {
        setTheme(colorScheme);
      }
    );
    return apperanceChangeListener.remove;
  }, []);

  return theme === "dark" ? DarkTheme : LightTheme;
};

export interface AppTheme {
  ACCENT: "#f99d39";
  PRIMARY: "#236e96";
  ERROR: "#E84E4F";
  TEXT: "#000000" | "#FFFFFF";
  BACKGROUND: "#F8F5F4" | "#000000";
  BACKGROUND_SECONDARY: "#1C1C1E" | "#FFFFFF";
  LIGHT_GREY: "#979594";
  WHITE: "#FFFFFF";
  DARK_GREY: "#585858" | "#FFFFFF";
}

enum DarkTheme {
  ACCENT = "#f99d39",
  PRIMARY = "#236e96",
  TEXT = "#000000",
  BACKGROUND_SECONDARY = "#1C1C1E",
  BACKGROUND = "#F8F5F4",
  LIGHT_GREY = "#979594",
  GREY = "#555555",
  WHITE = "#FFFFFF",
  DARK_GREY = "#585858",
  FORECOLOR = "#FFFFFF",
  ERROR = "#E84E4F",
}

export enum LightTheme {
  ACCENT = "#f99d39",
  PRIMARY = "#236e96",
  TEXT = "#000000",
  BACKGROUND_SECONDARY = "#FFFFFF",
  BACKGROUND = "#F8F5F4",
  LIGHT_GREY = "#979594",
  WHITE = "#FFFFFF",
  DARK_GREY = "#FFFFFF",
  FORECOLOR = "#000000",
  ERROR = "#E84E4F",
}
